"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Paginator = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var React = __importStar(require("react"));
var Icon_1 = require("../Icon/Icon");
var Page_1 = require("./Page");
require("./paginator.css");
var Paginator = /** @class */ (function (_super) {
    __extends(Paginator, _super);
    function Paginator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Paginator.prototype.isFirstPage = function () {
        var page = this.props.page;
        return page === 1;
    };
    Paginator.prototype.isLastPage = function () {
        var _a = this.props, page = _a.page, pages = _a.pages;
        return page >= pages;
    };
    Paginator.prototype.initList = function () {
        var _a = this.props, page = _a.page, onClick = _a.onClick;
        var list = [];
        list.push((0, jsx_runtime_1.jsx)(Page_1.Page, __assign({ onClick: onClick, isDisabled: this.isFirstPage(), page: page - 1 }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: "icon_arrow_left_dark" }) }), "arrow_left"));
        list.push((0, jsx_runtime_1.jsx)(Page_1.Page, __assign({ onClick: onClick, isActive: this.isFirstPage(), page: 1 }, { children: 1 }), "first_page"));
        return list;
    };
    Paginator.prototype.closeList = function (list) {
        var _a = this.props, page = _a.page, pages = _a.pages, onClick = _a.onClick;
        if (pages > 1) {
            list.push((0, jsx_runtime_1.jsx)(Page_1.Page, __assign({ onClick: onClick, isActive: this.isLastPage(), page: pages }, { children: pages }), "last_page"));
        }
        list.push((0, jsx_runtime_1.jsx)(Page_1.Page, __assign({ onClick: onClick, isDisabled: this.isLastPage(), page: page + 1 }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: "icon_arrow_right_dark" }) }), "arrow_right"));
        return list;
    };
    Paginator.prototype.renderPages = function () {
        var list = this.initList();
        var _a = this.props, page = _a.page, pagePrint = _a.pagePrint, onClick = _a.onClick, pages = _a.pages;
        if (Math.abs(1 - page) > pagePrint + 1) {
            list.push((0, jsx_runtime_1.jsx)("li", __assign({ className: "disabled" }, { children: "..." }), "prev_dot"));
        }
        var startPrintPage = Math.max(page - pagePrint, 2);
        var maxPagePrint = Math.min(pagePrint + page + 1, pages);
        for (var i = startPrintPage; i < maxPagePrint; i++) {
            list.push((0, jsx_runtime_1.jsx)(Page_1.Page, __assign({ onClick: onClick, page: i, isActive: i === page }, { children: i }), "page_".concat(i)));
        }
        if (Math.abs(page - pages) > pagePrint + 1) {
            list.push((0, jsx_runtime_1.jsx)("li", __assign({ className: "disabled" }, { children: "..." }), "next_dot"));
        }
        return this.closeList(list);
    };
    Paginator.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "paginator" }, { children: (0, jsx_runtime_1.jsx)("ul", { children: this.renderPages() }) })));
    };
    return Paginator;
}(React.PureComponent));
exports.Paginator = Paginator;
Paginator.defaultProps = {
    pagePrint: 4,
};
//# sourceMappingURL=Paginator.js.map